import React from 'react';
import DOMPurify from 'dompurify';

// Convert legacy plain-text content (with markdown-like syntax) to safe HTML.
// Used so existing pages keep rendering after switching renderer to HTML.
const legacyToHtml = (text) => {
  const lines = text.split('\n');
  let html = '';
  let inList = false;
  for (const raw of lines) {
    const line = raw.trim();
    if (line.startsWith('## ')) {
      if (inList) { html += '</ul>'; inList = false; }
      html += `<h2>${line.slice(3)}</h2>`;
    } else if (line.startsWith('### ')) {
      if (inList) { html += '</ul>'; inList = false; }
      html += `<h3>${line.slice(4)}</h3>`;
    } else if (line.startsWith('- ')) {
      if (!inList) { html += '<ul>'; inList = true; }
      html += `<li>${line.slice(2)}</li>`;
    } else if (line) {
      if (inList) { html += '</ul>'; inList = false; }
      html += `<p>${line}</p>`;
    }
  }
  if (inList) html += '</ul>';
  return html;
};

// Render rich-text HTML safely.
// Falls back to legacy markdown-like rendering for content saved before TipTap.
export const RichTextContent = ({ html, className = 'prose-content text-[#64748B] leading-relaxed' }) => {
  if (!html) return null;
  const looksLikeHtml = /<\/?[a-z][\s\S]*>/i.test(html);
  const finalHtml = looksLikeHtml ? html : legacyToHtml(html);
  const clean = DOMPurify.sanitize(finalHtml, {
    ALLOWED_TAGS: ['p', 'br', 'strong', 'b', 'em', 'i', 'u', 's', 'h1', 'h2', 'h3', 'h4', 'ul', 'ol', 'li', 'a', 'blockquote', 'hr', 'span', 'div'],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'style', 'class']
  });
  return <div className={className} dangerouslySetInnerHTML={{ __html: clean }} />;
};

export default RichTextContent;
